export default {
	sec_10: {
		title: {
			one: "JP WOLRD Pay's",
			two: 'own points system',
		},
		desc: {
			one: 'Fast and secure, self-service point system.',
			two: 'No hassle with fixed exchange rates.',
		},
		btn: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},
	sec_04: {
		title: 'Integration with all systems',
		desc: 'Both offline and online stores accept only JP WOLRD Pay',
		cards: {
			one: {
				title: {
					one: 'Kiosks and POS Machines',
				},
				description: {
					one: 'Pay freely anywhere.',
				},
			},
			two: {
				title: {
					one: 'Convenient charging',
				},
				description: {
					one: 'You can instantly top up your account ',
					two: 'using your preferred cryptocurrency',
					three: 'or credit card.',
				},
			},
		},
	},
};
